import React from "react";
import SummaryCard from "./SummaryCard"; // adjust path if needed
// import { formatNum, formatMoney } from "../../helpers/formatters"; // optional, can pass as props

export default function IftaSummaryCards({ calculation }) {
  if (!calculation) return null;

  const summary = calculation.summary;
  const formatNum = (val, decimals = 2) => {
    if (val === null || val === undefined || isNaN(val)) return `0`;
    return val?.toLocaleString("en-US", {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
  };
  // --- RENDER HELPERS ---
  const formatMoney = (val) => {
    if (val === null || val === undefined || isNaN(val)) return `$0.00`;
    const absVal = Math.abs(val);
    const formatted = absVal.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
    return val < 0 ? `(${formatted})` : formatted;
  };

  return (
    <div className="row g-3 mb-4">
      <div className=" col-3">
        <SummaryCard
          label="Total Distance"
          value={`${formatNum(summary?.totalMiles, 0)} mi`}
          color="blue"
          FontSize="font-size-report"
        />
      </div>

      <div className="col-3">
        <SummaryCard
          label="Fuel Purchased"
          value={`${formatNum(summary?.totalGallons, 0)} gal`}
          color="indigo"
             FontSize="font-size-report"
        />
      </div>

      <div className=" col-3">
        <SummaryCard
          label="Fleet Average MPG"
          value={formatNum(summary?.mpg, 1)}
          sublabel="Calculated from Total Miles / Total Gal"
          color="emerald"
             FontSize="font-size-report"
          highlight
        />
      </div>

      <div className=" col-3">
        <SummaryCard
          label="Estimated IFTA Tax"
          value={formatMoney(summary?.grandTotal)}
          color={summary?.grandTotal > 0 ? "amber" : "green"}
             FontSize="font-size-report"
          sublabel={
            summary?.grandTotal < 0 ? "Credit Owed to You" : "Balance Due"
            
          }
        />
      </div>
    </div>
  );
}
